var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.9375C14.1901 3.9375 15.3686 4.17191 16.4681 4.62734C17.5676 5.08278 18.5666 5.75031 19.4082 6.59185C20.2497 7.43338 20.9172 8.43242 21.3727 9.53193C21.8281 10.6314 22.0625 11.8099 22.0625 13C22.0625 14.1901 21.8281 15.3686 21.3727 16.4681C20.9172 17.5676 20.2497 18.5666 19.4082 19.4082C18.5666 20.2497 17.5676 20.9172 16.4681 21.3727C15.3686 21.8281 14.1901 22.0625 13 22.0625C11.8099 22.0625 10.6314 21.8281 9.53193 21.3727C8.43242 20.9172 7.43337 20.2497 6.59184 19.4082C5.75031 18.5666 5.08277 17.5676 4.62734 16.4681C4.17191 15.3686 3.9375 14.1901 3.9375 13C3.9375 11.8099 4.17191 10.6314 4.62734 9.53193C5.08278 8.43241 5.75032 7.43337 6.59185 6.59184C7.43338 5.75031 8.43242 5.08277 9.53194 4.62734C10.6315 4.17191 11.8099 3.9375 13 3.9375L13 3.9375Z",
    stroke: "#EAECF0",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.9375C14.9138 3.9375 16.7785 4.54337 18.3268 5.66828C19.8751 6.79319 21.0275 8.37939 21.6189 10.1995C22.2104 12.0197 22.2104 13.9803 21.6189 15.8005C21.0275 17.6206 19.8751 19.2068 18.3268 20.3317",
    stroke: "#FDA29B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing);
export default __webpack_public_path__ + "static/media/Ring.3b73c44c79c2a56a73796f38336804f7.svg";
export { ForwardRef as ReactComponent };